<template>

    <div class="input__component">

        <div class="input__container"
             :class="{
                   'input__focus': isFocus,
                   'input__error': error,
                   'input__valid': valid
                     }">

            <input class="input__input"
                   ref="input"
                   :placeholder="placeholder"
                   :type="type"
                   :name="name"
                   v-on:blur="onBlur"
                   v-on:keyup.enter="enter"
                   v-model="value"
                   @focus="eventFocus">

            <img v-if="valid && !error" src="/img/inputs/input-success.svg" class="input__icon">

            <img v-if="error && !valid" src="/img/inputs/input-error.svg" class="input__icon">

        </div>

        <p class="input__label">
            <span v-if="error">{{ errorText }}</span>
        </p>

    </div>

</template>

<script>

export default {

    name: 'input-2',

    props: {

        default: {
            type: String,
            default: ''
        },

        placeholder: {
            type: String,
            default: ''
        },

        type: {
            type: String,
            default: 'text'
        },

        name: {
            type: String,
            default: ''
        },

        error: {
            type: Boolean,
            default: false
        },

        valid: {
            type: Boolean,
            default: false
        },

        errorText: {
            type: String,
            default: ''
        }

    },

    watch: {

        value: function (value) {
            this.$emit('update', value)
        }
    },

    data() {
        return {
            isFocus: false,
            value: ''
        }
    },

    mounted() {

        this.value = this.default
    },

    methods: {

        enter() {
            this.$emit('pressEnter')
        },

        onBlur() {
            this.$emit('blur')
            this.isFocus = false
        },

        eventFocus() {
            this.$emit('focus')
            this.isFocus = true
        }
    }

}

</script>

<style scoped lang="scss">

    .input {

        &__component {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 100%;
        }

        &__container {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 45px;
            border-radius: 100px;
            border: solid 2px $silver;
            padding: 12px 16px;
        }

        &__input {
            width: 100%;
            font-size: 16px;
            font-weight: 600;
            line-height: 1.31;
            color: $midnight;
        }

        &__focus {
            border-color: $aquamarine;
        }

        &__error {
            border-color: $raspberry;
        }

        &__valid {
            border-color: $lime;
        }

        &__icon {
            position: absolute;
            right: 16px;
            width: 24px;
            height: 24px;
        }

        &__label {
            min-height: 13px;
            margin-top: 4px;
            font-size: 11px;
            line-height: 1.18;
            color: $raspberry;
            text-align: left;
            margin-bottom: 4px;
        }

    }

</style>
